import { Directive } from "vue";
import CmsService from "../services/cms/cms-service";
import { CmsDocument } from "../services/cms/cms-type-definitions";
import cmsContentMap from "../services/cms/cms-content-map";

const cms = new CmsService();
let doc: CmsDocument | null = null;
// eslint-disable-next-line import/prefer-default-export
export const TextFromPrismic: Directive = {
  created: async (el, binding) => {
    if (!doc) doc = await cms.cmsStore.getById(cmsContentMap.settings.stringsId);

    const key = binding.value ?? (binding as any).expression;
    const value = (doc?.data as any).body[0].items.find((x) => x.key === key)?.value;

    if (value) el.innerHTML = cms.asHtml(value);
  },
};
